import type {HTMLChakraProps} from '@chakra-ui/react';
import {forwardRef, useEditableContext} from '@chakra-ui/react';
import {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';

import {useEditableFieldsStyleConfig} from '../../theme-config';

export const EditableContent = forwardRef<HTMLChakraProps<'div'>, 'div'>((props, ref) => {
  const {isEditing} = useEditableContext();
  const styles = useEditableFieldsStyleConfig({...props, isEditing});

  return <ChakraDiv __css={styles.content} {...props} ref={ref} />;
});
